"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnersDisplayGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
var UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
function memoizedGetColumns(metricsDataCatalogEnabled) {
    var ownedMetricsColumn = function (sortParams) { return ({
        name: 'ownedMetrics',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderOwnedMetrics(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams, 'right'),
        cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
            var metricsCount = _a.metricsCount;
            return metricsCount;
        }),
        resizable: true,
        sortable: false,
    }); };
    return __spreadArray([
        function () { return data_catalog_shared_1.createSelectionColumn(); },
        function (sortParams) { return ({
            name: 'name',
            dataKey: globalTypes_1.TableauUserOrderField.NAME,
            headerText: Localize_1.Messages.GridHeaderName(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (user) { return user; }),
            resizable: true,
            sortable: sortParams.areUsersVisible,
        }); },
        function (sortParams) { return ({
            name: 'ownedWorkbooks',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderOwnedWorkbooks(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams, 'right'),
            cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
                var workbookCount = _a.workbookCount;
                return workbookCount;
            }),
            resizable: true,
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'ownedDatasources',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderOwnedDatasources(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams, 'right'),
            cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
                var datasourceCount = _a.datasourceCount;
                return datasourceCount;
            }),
            resizable: true,
            sortable: false,
        }); }
    ], (metricsDataCatalogEnabled ? [ownedMetricsColumn] : []));
}
function OwnersDisplayGrid(props) {
    var areUsersVisible = React.useContext(data_catalog_shared_1.UserAndSiteSettingsContext).areUsersVisible;
    return (React.createElement(data_catalog_shared_1.FeatureFlagsContext.Consumer, null, function (featureFlags) {
        return React.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: memoizedGetColumns(featureFlags.metricsDataCatalogEnabled)
                .map(function (columnFactory) { return columnFactory(__assign(__assign({}, props), { areUsersVisible: areUsersVisible })); }), rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    }));
}
exports.OwnersDisplayGrid = OwnersDisplayGrid;
//# sourceMappingURL=OwnersDisplayGrid.js.map